import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const LensListPageHeight = styled.div`
    > div {
        /* calc header size - account for top nav (88px) + page header (~80px) */
        height: calc(100vh - 168px);
        min-height: 600px;
    }
`;

export const LensPageTabs = css`
    margin-top: ${Spacing.LG}px;
`;

export const TabStyle = css`
    margin: ${Spacing.SM}px 0;

    > ul {
        border-bottom: 1px solid ${Colors.Gray.V150};
    }

    ul > li {
        font-weight: 500;
        color: ${Colors.Black.V50};
        text-align: center;
        outline: none;
    }
`;
